// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"4b3e2ab8","977":"4c5c9a23"}[chunkId] + ".chunk.js";
};